export const RAW_UPDATE = 'RAW_UPDATE';
export const makeRawUpdate = (path, value) => ({
  type: RAW_UPDATE,
  path,
  value,
});
